import { selectToken } from '../selectors';
import { getState } from '../../../helpers';
import { EXEED } from './cheryTiggo8Pro';


export default () => {
  const token = selectToken(getState());
  return token === EXEED;
};
